import "./progress.css"
import { useState, useEffect } from "react"
import { RootState, useTypedSelector } from "../app/store"
import {
  useGetWeeksByMonthQuery,
  useGetMicroLearningByUserIdQuery,
  useGetMeasureScoresByUserIdQuery,
  useGetMonthByMicroLearningIdQuery,
  UserMicroLearningMonth,
  UserMicroLearningWeek,
} from "../app/services/meseeknaApi"
import { skipToken } from "@reduxjs/toolkit/query"
import HeaderSection from "../components/header-section"
import Sidebar from "../features/sidebar/components/sidebar"
import { useParams } from "react-router-dom"

// Define a type for the question object
type RandomResponse = {
  question: string
  answer: string
  id: string
  type: string
}

const ProgressComponent = () => {
  const [category, setCategory] = useState("Goals")
  const [data, setData] = useState<UserMicroLearningMonth[]>([])
  const [weekData, setWeekData] = useState<UserMicroLearningWeek[]>([])
  const [monthNumber, setMonthNumber] = useState<number>()
  const [monthStatus, setMonthStatus] = useState<string>("month")
  const [measureIcon, setMeasureIcon] = useState<string>()
  const [selection, setSelection] = useState("")
  const [responseData, setResponseData] = useState<RandomResponse[]>([])
  const [weekNumber, setWeekNumber] = useState<number>()
  const [microId, setMicroId] = useState<number>()
  const { runId } = useParams()
  const authStore = useTypedSelector((state: RootState) => {
    return state.authSlice
  })
  const { data: weeksByMonthData, isLoading: weeksByMonthIsLoading } =
    useGetWeeksByMonthQuery(monthNumber ? { id: monthNumber } : skipToken)
  const { data: microLearningsData, isLoading: microLearningByUserIdLoading } =
    useGetMicroLearningByUserIdQuery({
      userId: authStore.user.id,
      assignedTestId: Number(runId),
    })
  const {
    data: MonthByMicroLearningIdsData,
    isLoading: MonthByMicroLearningIdLoading,
  } = useGetMonthByMicroLearningIdQuery(
    microId ? { microId: microId } : skipToken,
  )

  const { data: measureScoresData, isFetching: isFetchingMeasureScoresData } =
    useGetMeasureScoresByUserIdQuery({ id: authStore.user.id })

  useEffect(() => {
    if (!microLearningByUserIdLoading && !isFetchingMeasureScoresData) {
      fetchGoalsData()
    }
  }, [
    microLearningsData,
    measureScoresData,
    microLearningByUserIdLoading,
    isFetchingMeasureScoresData,
  ])

  const fetchGoalsData = () => {
    setMicroId(microLearningsData?.data[0]?.id)
    setSelection(microLearningsData?.data[0]?.microlearningProgress || "")
    let icon = "null"
    measureScoresData?.data.forEach((element) => {
      if (element.measureId === microLearningsData?.data[0]?.measureId) {
        icon = element.iconUrl
      }
    })

    setMeasureIcon(icon)
  }
  useEffect(() => {
    if (MonthByMicroLearningIdsData) {
      setData(MonthByMicroLearningIdsData.data)
    }
  }, [MonthByMicroLearningIdsData])

  const handleCategorySwitch = (item: string) => {
    setMonthStatus("month")
    setCategory(item)
  }

  const handleCourse = () => {
    setMonthStatus("month")
    setCategory("Course Progress")
  }

  const handleMonth = (data: UserMicroLearningMonth) => {
    setMonthStatus("week")
    setMonthNumber(data.monthNumber)
  }
  useEffect(() => {
    if (weeksByMonthData?.data) {
      setWeekData(weeksByMonthData.data)
    }
  }, [weeksByMonthData])

  const handleWeeks = (element: UserMicroLearningWeek) => {
    setWeekNumber(element.weekNumber)
    if (element.weekNumber) {
      const filteredWeekData = weekData.filter(
        (each) => each.weekNumber == element.weekNumber,
      )

      if (filteredWeekData[0] && filteredWeekData[0].response) {
        const response = JSON.parse(
          filteredWeekData[0].response,
        ) as RandomResponse[]
        setResponseData(response)
      } else {
        setResponseData([
          {
            question: "How do you rate yourself",
            answer: "10",
            id: "GmSmwtsssplX",
            type: "opinion_scale",
          },
          {
            question: "Some long text",
            answer: "meseekna Application",
            id: "pW2aCLzJ7IiA",
            type: "long_text",
          },
        ])
      }
    }
  }

  return (
    <div className="relative bg-base-white w-full h-[100dvh] flex flex-row items-start justify-start font-text-md-regular">
      <Sidebar />
      <div className="w-full h-[100dvh] flex-1 flex flex-col">
        <HeaderSection hideBreadcrumbs hideHelpIcon hideProfileIcon />

        <div className="container-fluid">
          <nav className="nav">
            {["Goals", "Course Progress"].map((item) => (
              <a
                key={item}
                className={`nav-link-1 ${category === item ? "active" : ""}`}
                onClick={() => handleCategorySwitch(item)}>
                {item}
              </a>
            ))}
          </nav>
          <div className="dashboard-nav">
            {category === "Goals" && (
              <>
                {microLearningByUserIdLoading || isFetchingMeasureScoresData ? (
                  <div className="spin">
                    <div className="d-flex justify-content-center">
                      <div className="spinner-border text-info" role="status">
                        <span className="sr-only">Loading...</span>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div
                    className="row"
                    style={{
                      height: "100%",
                      display: "flex",
                      flexWrap: "wrap",
                    }}>
                    <div className="col-6 m-0">
                      <div className="g-1">
                        <h1>User Specific Measure</h1>
                        <div
                          className=""
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "center",
                            height: "15vh",
                          }}>
                          <div className="box-1">
                            <img
                              src={measureIcon}
                              alt="Measure Icon"
                              style={{ height: "inherit" }}
                            />
                          </div>
                        </div>
                        <h3>The goal of this course is to....</h3>
                      </div>
                    </div>
                    <div className="col-6 m-0">
                      <div className="g-2" onClick={handleCourse}>
                        {selection === "flower" ? (
                          <img src="/v3/assets/Flower_3.png" alt="Flower" />
                        ) : selection === "mountain" ? (
                          <img src="/v3/assets/Mountain_1.png" alt="Mountain" />
                        ) : (
                          <img
                            // style={{height:"150px"}}
                            src="/v3/assets/Puzzle_1.png"
                            alt="Puzzle"
                          />
                        )}
                      </div>
                    </div>
                  </div>
                )}
              </>
            )}
            {category === "Course Progress" && (
              <div className="course-main">
                {weeksByMonthIsLoading || MonthByMicroLearningIdLoading ? (
                  <div className="spin">
                    <div className="d-flex justify-content-center">
                      <div className="spinner-border text-info" role="status">
                        <span className="sr-only">Loading...</span>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div>
                    {monthStatus === "month" ? (
                      <div className="course">
                        <div className="d-flex flex-column justify-content-center">
                          {data.length !== 0 ? (
                            <div className="row">
                              {data.map((dataItem) => (
                                <div
                                  className="col-4"
                                  key={dataItem.monthNumber}>
                                  <div
                                    className="month"
                                    onClick={() => handleMonth(dataItem)}>
                                    <div className="progress-bar-vertical">
                                      <div
                                        className={`progress-striped progress-bar-${dataItem.monthStatus}`}
                                        role="progressbar"
                                        aria-valuenow={60}
                                        aria-valuemin={0}
                                        aria-valuemax={100}></div>
                                    </div>

                                    {/* circles */}
                                    {(dataItem.monthNumber === 1 ||
                                      dataItem.monthNumber === 2 ||
                                      dataItem.monthNumber === 5 ||
                                      dataItem.monthNumber === 4) && (
                                      <div className="link-bar">
                                        <img
                                          src="/v3/assets/circle.png"
                                          className="fontinc"
                                        />
                                        <img
                                          src="/v3/assets/circle.png"
                                          className="fontincrement"
                                        />
                                        <img
                                          src="/v3/assets/circle.png"
                                          className="fontinc1"
                                        />
                                      </div>
                                    )}
                                    <div className="try p-4">
                                      <div className="row  inherit-width">
                                        <div className="col-6 pe-0">
                                          <h1 className="p-0">
                                            Month {dataItem.monthNumber}
                                          </h1>
                                        </div>
                                        <div className="col-6 d-flex flex-column justify-content-center align-items-end">
                                          <img
                                            src="/v3/assets/right.png"
                                            className="openfolder"
                                            alt="Open Folder"
                                          />
                                        </div>
                                      </div>
                                      <p style={{ marginTop: "8px" }}>
                                        {dataItem.monthDescription}
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              ))}
                            </div>
                          ) : (
                            <div className="course-12 d-flex flex-column justify-content-center align-content-center">
                              <div className="text-center text-edit">
                                No Data Found
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    ) : (
                      <div className="course-main-1">
                        <div className="course-3">
                          <h1 className="text-center week-main">
                            Month {monthNumber}
                          </h1>
                          <div className="accordion" id="accordionExample">
                            {weekData.map((week) => (
                              <div
                                className="accordion-item"
                                key={week.weekNumber}>
                                <h2
                                  className="accordion-header"
                                  id={`head${week.weekNumber}`}>
                                  <button
                                    className="accordion-button collapsed"
                                    id={`accordButton${week.weekNumber}`}
                                    onClick={() => handleWeeks(week)}
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target={`#body${week.weekNumber}`}
                                    aria-expanded="true"
                                    aria-controls={`body${week.weekNumber}`}>
                                    Week-{week.weekNumber}
                                  </button>
                                </h2>
                                <div
                                  id={`body${week.weekNumber}`}
                                  className="accordion-collapse collapse"
                                  aria-labelledby={`head${week.weekNumber}`}
                                  data-bs-parent="#accordionExample">
                                  <div className="accordion-body">
                                    <div className="course-4">
                                      <h1 className="text-center week-main">
                                        Month {monthNumber}
                                      </h1>
                                      <h1 className="week-main">
                                        Week {weekNumber}
                                      </h1>
                                      {responseData.map((data) => (
                                        <div className="weekss" key={data.id}>
                                          <div className="prompt">
                                            <p>{data.question}</p>
                                          </div>
                                          <div className="prompt-below">
                                            <div className="prompt-main">
                                              <p>{data.answer}</p>
                                            </div>
                                          </div>
                                        </div>
                                      ))}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default ProgressComponent
